export const defaultValueLanguage = { value: 'all', label: 'All languages' }
export const defaultValueIntent = { value: 'all', label: 'All intents' }
export const defaultFallbackIntent = 'Default Fallback Intent'
